module.exports = __webpack_public_path__ + "img/graphql.7c64d4f7.png";